import React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate, TranslatePlural } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { SortSelector } from '#src/app/pages/searchV2/shared/components';

import { useSearchQueryResultText } from './hooks/useSearchQueryResultText';

export const SearchQueryResultText: React.FC = () => {
	return (
		<div className="container mt-16 hidden items-center justify-between md:flex">
			<ClientRender placeholder={<LoadingSkeleton />}>
				<ResultText />
			</ClientRender>
			<SortSelector desktopView />
		</div>
	);
};

const ResultText: React.FC = () => {
	const {
		data: { query, countLocalized, count, isLoading },
	} = useSearchQueryResultText();

	if (isLoading) {
		return <LoadingSkeleton />;
	}

	return (
		<Text as="h1" variant="heading" size="small" fontWeight="light" className="my-0">
			{query ? (
				<Translate
					value="corgi.search.header.subtitle"
					replacements={{
						query,
						countLocalized,
					}}
				/>
			) : (
				<TranslatePlural
					value="corgi.search.header.mobile_subtitle"
					replacements={{
						countLocalized,
					}}
					count={count}
				/>
			)}
		</Text>
	);
};

const LoadingSkeleton: React.FC = () => (
	<div className="animate-pulse" data-testid="loading-skeleton">
		<div className="bg-fill-press h-7 w-75 rounded" />
	</div>
);
